import React from 'react';
import clsx from 'clsx';
import RowElement from '../DataElements/RowElement'

const CheckboxComponent = (props) => {

    const {
        deleteComponent
    } = props 

    const [displayContent, setDisplayContent] = React.useState(false); 


    return(
        <div className={clsx('spacingTopDiv')}>
            <RowElement
                label='Checkbox'
                displayContent={displayContent}
                setDisplayContent={setDisplayContent}
                deleteElement={deleteComponent}
            />
            <div className={clsx('spacingTopDiv', 'spacingLeftDiv','spacingRightDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>  
                <div className={clsx('spacingLeftDiv','spacingTopDiv')}>
                    No attributes options for this component
                </div>
            </div>
            <hr className={clsx('blueLine','spacingTopDiv')}/> 
        </div>
    )

}

export default CheckboxComponent;